
import React from "react";
import Navbartl from "../Navbartailwind.js";
import Projects from "../Project.js";

const projectpageold = () => {
  return (
    <div>
      <Navbartl></Navbartl>
     <Projects></Projects>
    </div>
    
    
   
  );
};

export default projectpageold;
